import { useEffect } from "react";

import { useFaireDirectCreatePendingRelationship } from "@faire/retailer/hooks/FaireDirect/useFaireDirectCreatePendingRelationship/useFaireDirectCreatePendingRelationship";
import { useSettingFaireDirectRelationshipCreation } from "@faire/retailer/settings/useSettingFaireDirectRelationshipCreation";

export const useCreateFaireDirectRelationshipEffect = () => {
  const {
    createPendingRelationship,
    alreadyAttemptedToCreatePendingRelationship,
  } = useFaireDirectCreatePendingRelationship();

  const enableFaireDirectRelationshipCreation =
    useSettingFaireDirectRelationshipCreation();

  useEffect(() => {
    if (
      !enableFaireDirectRelationshipCreation ||
      alreadyAttemptedToCreatePendingRelationship
    ) {
      return;
    }
    createPendingRelationship();
  }, [
    alreadyAttemptedToCreatePendingRelationship,
    createPendingRelationship,
    enableFaireDirectRelationshipCreation,
  ]);
};
